import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from '@/common/components/Helmet'
import { titleTagSuffix } from '@/common/constants'
import { useSetDetail } from '@/pages/organizations/detail/sets/detail'
import OrganizationSetDetailPageContent from '@/pages/organizations/detail/sets/detail/_components/OrganizationSetDetailPageContent'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/sets/$setId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const {
    assessment,
    organization,
    responses,
    qtyActualResponses,
    qtyPossibleResponses,
    userCanInviteUser,
    userCanViewAssessments,
  } = useSetDetail()

  return (
    <>
      <Helmet>
        <title>
          {assessment.name}
          {titleTagSuffix}
        </title>
        <meta property="og:title" content={assessment.name} />
      </Helmet>
      <OrganizationSetDetailPageContent
        assessment={assessment}
        assessmentLoading={false}
        organization={organization}
        responses={responses}
        qtyActualResponses={qtyActualResponses}
        qtyPossibleResponses={qtyPossibleResponses}
        userCanInviteUser={userCanInviteUser}
        userCanViewAssessments={userCanViewAssessments}
      />
    </>
  )
}
